window.GLG = window.GLG || {};

window.GLG.AiScorecardReview = (function () {
  function playerBlockFrom($el) {
    return $el.closest(".player-review");
  }

  function recalcRow($block, eighteenHoles) {
    var sumFirstNine = 0;
    var sumLastNine = 0;
    var sumTotal = 0;

    $block.find(".hole-input").each(function () {
      var holeNumber = parseInt($(this).data("hole-number"));
      var val = $(this).val();
      var score = val === "X" ? 0 : parseInt(val);

      if (isNaN(score)) return;

      sumTotal += score;
      if (holeNumber <= 9) { sumFirstNine += score; } else { sumLastNine += score; }
    });

    $block.find(".player-total").text(sumTotal);
    if (eighteenHoles) {
      $block.find(".first-nine-total").text(sumFirstNine);
      $block.find(".last-nine-total").text(sumLastNine);
    }
  }

  function bindRecalc(eighteenHoles) {
    $(document).off("blur.ai-review", ".hole-input").on("blur.ai-review", ".hole-input", function () {
      recalcRow(playerBlockFrom($(this)), eighteenHoles);
    });
  }

  function setIncluded($block, included) {
    $block.toggleClass("is-excluded", !included);
    $block.find(".hole-input, .competitor-select").prop("disabled", !included);
  }

  function bindIncludeToggle() {
    $(document).off("change.ai-review", ".row-include-checkbox").on("change.ai-review", ".row-include-checkbox", function () {
      setIncluded(playerBlockFrom($(this)), $(this).is(":checked"));
    });
  }

  function bindExcludedClick() {
    $(document).off("click.ai-review-enable", ".player-review.is-excluded").on("click.ai-review-enable", ".player-review.is-excluded", function (e) {
      if ($(e.target).closest(".player-review__include").length) return;

      $(this).find(".row-include-checkbox").prop("checked", true).trigger("change");
    });
  }

  function syncIncludedState() {
    $(".player-review").each(function () {
      var $block = $(this);
      setIncluded($block, $block.find(".row-include-checkbox").is(":checked"));
    });
  }

  function bindImportGuard() {
    $("#import-scores-btn").off("click.ai-review").on("click.ai-review", function (e) {
      if ($(".row-include-checkbox:checked").length === 0) {
        e.preventDefault();
        alert("Select at least one player to import.");
      }
    });
  }

  function startPoll(config) {
    var interval = setInterval(function () {
      $.getJSON(config.pollUrl, function (data) {
        if (data.status === "ready" || data.status === "failed") {
          clearInterval(interval);
          window.location.href = config.reviewUrl;
        }
      });
    }, 3000);
  }

  return {
    init: function (config) {
      if (!config) return;

      bindRecalc(config.eighteenHoles);
      bindIncludeToggle();
      bindExcludedClick();
      bindImportGuard();
      syncIncludedState();

      if (config.pollUrl && config.reviewUrl) {
        startPoll(config);
      }
    }
  };
})();
